import debounce from "lodash/debounce";

const fetchOptionsForData = data => ({
  method: "POST",
  credentials: "include",
  headers: {
    "Content-Type": "application/json",
    "X-CSRF-Token": Session.authenticity_token,
  },
  body: JSON.stringify({ data }),
});

export const track = debounce((event, properties = {}) => {
  fetch("/track", fetchOptionsForData({ event, properties }));
}, 250);

export const identify = debounce((properties = {}) => {
  fetch("/identify", fetchOptionsForData({ properties }));
}, 250);
